import React, { useMemo } from "react";
import "./FicheToolkit.scss";
import { MoreInfo } from "../../MoreInfo/MoreInfo";
import { Image } from "../../../Image/Image";
import { FicheType } from "../../FicheType/FicheType";

export const FicheToolkit = (props) => {
  console.log(props);

  const bodyItems = useMemo(() => {
    let items = props.processFicheItems(props.data.body.items);
    return items;
  });

  return (
    <div
      className={`c-fiche c-toolkit-full ${
        props.data?.hasDetail ? "u-has-detail" : ""
      }`}
      onClick={() => {
        if (props.data?.hasDetail && props.openPopup) {
          props.openPopup(props.data.urlSegment);
        }
      }}
      data-aos="fade-up"
    >
      <div>
        <FicheType
          type={props.data.type}
          style={{
            backgroundColor:
              props.data.typeColor != null
                ? "#" + props.data.typeColor
                : "unset",
          }}
        />
        <div className="image" title="Meer over">
          {props.data?.image?.url && (
            <Image
              alt={props.data.title}
              src={props.data.image && props.data.image.url}
            />
          )}
        </div>
        <header className="c-fiche__header">
          <h2
            className="title"
            title={props.title}
            dangerouslySetInnerHTML={{ __html: props.data.title }}
          ></h2>
        </header>
        <div className="c-fiche__body">
          <ul>{bodyItems}</ul>
        </div>
        <MoreInfo
          data={props.data}
          openPopup={props.openPopup}
          cta={props.dictionary.moreInfo}
        />
      </div>
    </div>
  );
};
